import { ArtistVerifyRejectReason } from '@/api/artistVerify';
import { Input, Modal, Radio, Space } from 'antd';
import { useEffect, useMemo, useState } from 'react';

interface RejectDialogProps {
  dialogTitle?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: ArtistVerifyRejectReason, remark: string) => void;
  isLoading: boolean;
}

const RejectDialog = ({
  dialogTitle = '驳回认证原因',
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: RejectDialogProps) => {
  const [value, setValue] = useState<string>();
  const [textValue, setTextValue] = useState<string>('');

  useEffect(() => {
    if (!isOpen) {
      setValue(undefined);
      setTextValue('');
    }
  }, [isOpen]);

  const handleOk = () => {
    onConfirm(Number(value) as ArtistVerifyRejectReason, textValue);
  };

  const confirmDisabled = useMemo(() => {
    return (
      (value === `${ArtistVerifyRejectReason.OTHER}` && textValue === '') ||
      !value
    );
  }, [value, textValue]);

  return (
    <Modal
      open={isOpen}
      title={dialogTitle}
      width={500}
      onCancel={onClose}
      onOk={handleOk}
      okText="确定"
      cancelText="取消"
      okButtonProps={{
        disabled: confirmDisabled,
        danger: true,
        loading: isLoading,
      }}
      destroyOnClose
    >
      <Radio.Group
        onChange={(e) => {
          setValue(e.target.value as string);
          setTextValue('');
        }}
        value={value}
        style={{ marginBottom: 10 }}
      >
        <Space direction="vertical">
          <Radio
            value={`${ArtistVerifyRejectReason.NOT_REACH_ARTIST_STANDARD}`}
          >
            未达艺术标准
          </Radio>
          <Radio value={`${ArtistVerifyRejectReason.CERTIFICATION_FRAUD}`}>
            认证造假
          </Radio>
          <Radio value={`${ArtistVerifyRejectReason.ARTIST_IDENTITY_INVALID}`}>
            艺术家身份失效
          </Radio>
          <Radio
            value={`${ArtistVerifyRejectReason.FAKE_DOCUMENT_OR_FAKE_PROOF}`}
          >
            假证件/假证明
          </Radio>
          <Radio value={`${ArtistVerifyRejectReason.OTHER}`}>
            其它（备注）
          </Radio>
        </Space>
      </Radio.Group>

      <Input.TextArea
        placeholder="请输入不通过原因"
        rows={4}
        value={textValue}
        onChange={(e) => setTextValue(e.target.value)}
        disabled={value !== `${ArtistVerifyRejectReason.OTHER}`}
      />
    </Modal>
  );
};

export default RejectDialog;
